import Guid from '@/components/Guid'

export class OrmItemCommentModel {
  constructor() {
    this.quoteItemId = Guid.empty()
    this.comment = ''
  }
}
